/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import {
  StyledChangeRegionDropdown,
  StyledLocaleButton,
  StyledLocalePanel,
  StyledLocaleGrid,
  StyledLocaleItem,
  StyledFlagIcon,
} from './ChangeRegionDropdown.styled';
import { DEFAULT_LOCAL_CODE, LOCALES } from '../../../constants';

const ChangeRegionDropdown = function ({ selectedLocale = DEFAULT_LOCAL_CODE, onLocaleChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleLocaleSelect = (locale) => {
    if (onLocaleChange && locale.code !== selectedLocale) {
      onLocaleChange(locale);
    }
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const currentLocale = LOCALES.find((l) => l.code === selectedLocale) || LOCALES[0];
  const CurrentFlagIcon = currentLocale.icon;

  return (
    <StyledChangeRegionDropdown ref={dropdownRef}>
      <StyledLocaleButton onClick={toggleDropdown}>
        <Flex alignItems="center" gap="8px">
          <StyledFlagIcon>
            <CurrentFlagIcon />
          </StyledFlagIcon>
          <Text fontSize="14px" fontWeight="500">
            {currentLocale.name}
          </Text>
        </Flex>
      </StyledLocaleButton>

      {isOpen && (
        <StyledLocalePanel>
          <Box p="16px">
            <Text fontSize="16px" fontWeight="600" mb="16px">
              Select the region
            </Text>
            <StyledLocaleGrid>
              {LOCALES.map((locale) => {
                const FlagIcon = locale.icon;
                return (
                  <StyledLocaleItem
                    key={locale.code}
                    onClick={() => handleLocaleSelect(locale)}
                    isSelected={locale.code === selectedLocale}
                  >
                    <Flex alignItems="center" gap="8px">
                      <StyledFlagIcon>
                        <FlagIcon />
                      </StyledFlagIcon>
                      <Text fontSize="14px">{locale.name}</Text>
                    </Flex>
                  </StyledLocaleItem>
                );
              })}
            </StyledLocaleGrid>
          </Box>
        </StyledLocalePanel>
      )}
    </StyledChangeRegionDropdown>
  );
};

export default ChangeRegionDropdown;
